/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { useEffect, useState } from "react";
import { areServiceWorkersSupported } from "dc-preview-utils/src/Utils/ServiceWorkerUtils";
import { liquidModeNetworkProxyTechnology } from "constants/enums";

const useNetworkProxyDetector = () => {
  const [networkProxyTechnology, setNetworkProxyTechnology] = useState(liquidModeNetworkProxyTechnology.NONE);

  useEffect(() => {
    if (areServiceWorkersSupported()) {
      setNetworkProxyTechnology(liquidModeNetworkProxyTechnology.SERVICE_WORKERS);
    }
  }, []);

  return { networkProxyTechnology };
};

const NetworkProxyDetector = ({ setNetworkProxyTechnology }) => {
  const { networkProxyTechnology } = useNetworkProxyDetector();

  useEffect(() => {
    setNetworkProxyTechnology(networkProxyTechnology);
  }, [networkProxyTechnology]);
  return null;
};

export default NetworkProxyDetector;
